import { Reveal, ClipImage, SectionHead } from "./Reveal";

const STEPS = [
  ["Consulenza", "Analizziamo insieme viso, tipo di pelle e il risultato che desideri."],
  ["Progettazione", "Disegniamo la forma su misura, seguendo le proporzioni del tuo volto, e scegliamo il pigmento."],
  ["Trattamento", "Con uno strumento sottile dotato di micro aghi si tatuano i peli imitando quelli naturali."],
  ["Ritocco", "Dopo alcune settimane si perfezionano intensità e dettagli per un risultato uniforme."],
];

const FACTS = [
  ["12–18", "mesi", "Durata indicativa del risultato, variabile in base a pelle e stile di vita."],
  ["4–6", "settimane", "Tempo consigliato prima del ritocco di perfezionamento."],
  ["1:1", "pelo a pelo", "Ogni tratto è disegnato a mano per un effetto naturale, mai \u201ctatuato\u201d."],
];

const CARE = ["Lavare con acqua tiepida e sapone neutro", "Evita sole diretto, sauna e piscina", "Non grattare né rimuovere le crosticine", "Applica solo i prodotti consigliati"];

export const Microblading = () => (
  <section id="microblading" data-testid="microblading-explainer-section" className="relative py-24 md:py-36">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="grid gap-14 lg:grid-cols-12 lg:gap-20">
        <div className="lg:col-span-7">
          <SectionHead num="01" eyebrow="Sopracciglia" title={<>Cos'è il <em className="gold-text italic">microblading</em></>} />
          <Reveal delay={0.1} className="mt-10 grid gap-6 text-base leading-relaxed text-[var(--ink-soft)] md:grid-cols-2 md:text-lg">
            <p>Il microblading è una tecnica di trucco semipermanente manuale ed estremamente naturale. Ha lo scopo di perfezionare le sopracciglia ricreando i peli naturali depositando appositi pigmenti nel derma attraverso l'utilizzo di uno speciale strumento dotato di micro aghi, il Tool.</p>
            <p>Il risultato sono sopracciglia più piene e definite, con un aspetto naturale. È ideale per chi ha sopracciglia rade, asimmetriche o vuole semplicemente svegliarsi già in ordine.</p>
          </Reveal>
        </div>
        <ClipImage src="/img/micro-aura.webp" alt="Microblading sopracciglia realizzato da AURA" testid="microblading-image" className="aspect-[4/5] w-full lg:col-span-5 lg:-mt-10" frame="rounded-t-[999px] rounded-b-[2rem]" />
      </div>

      <div className="mt-24">
        <Reveal><p className="eyebrow mb-10">Il percorso</p></Reveal>
        <div className="grid gap-px overflow-hidden rounded-[2rem] border border-[var(--gold)]/25 bg-[var(--gold)]/25 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map(([t, d], i) => (
            <Reveal key={t} delay={i * 0.08} data-testid={`microblading-step-${i + 1}`} className="group bg-[var(--cream)] p-8 transition-colors duration-500 hover:bg-white md:p-10">
              <span className="font-display text-5xl italic text-[var(--gold)] transition-transform duration-500 group-hover:-translate-y-1 inline-block">0{i + 1}</span>
              <h3 className="mt-8 font-display text-2xl">{t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[var(--ink-soft)] md:text-base">{d}</p>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="mt-6 grid gap-6 lg:grid-cols-12">
        <div className="grid gap-6 sm:grid-cols-3 lg:col-span-8">
          {FACTS.map(([n, u, d], i) => (
            <Reveal key={u} delay={i * 0.08} className="flex flex-col justify-between rounded-[2rem] bg-[var(--blush)]/70 p-8">
              <div><span className="font-display text-5xl">{n}</span><span className="ml-2 text-sm uppercase tracking-[0.2em] text-[var(--gold-deep)]">{u}</span></div>
              <p className="mt-8 text-sm leading-relaxed text-[var(--ink-soft)]">{d}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2} className="rounded-[2rem] bg-[var(--ink)] p-8 text-[var(--cream)] lg:col-span-4" data-testid="microblading-care">
          <p className="text-xs uppercase tracking-[0.28em] text-[var(--nude)]">Dopo il trattamento</p>
          <ul className="mt-6 space-y-4">
            {CARE.map((c) => (
              <li key={c} className="flex gap-3 border-b border-white/10 pb-4 text-sm last:border-0 md:text-base"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[var(--gold)]" />{c}</li>
            ))}
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
);
